/**
 * Do not edit directly
 * Generated on Fri, 27 Mar 2026 10:29:26 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";